import { render } from "./ClvAnalysis.vue?vue&type=template&id=64f5c780&scoped=true"
import script from "./ClvAnalysis.vue?vue&type=script&lang=js"
export * from "./ClvAnalysis.vue?vue&type=script&lang=js"

import "./ClvAnalysis.vue?vue&type=style&index=0&id=64f5c780&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4197/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f5c780"]])

export default __exports__